module.exports = __webpack_public_path__ + "icons/logout.137d797272bcb2d5ea5318daf109b3d4.svg";